<template>
  <div @click="getDetail" class="pointer accent_color text-dense">
    {{ name }}
  </div>
</template>

<script>
export default {
  computed: {
    name() {
      return this.params.data.debtor && this.params.data.debtor.name;
    },
    customer() {
      return this.params.data.debtor;
    },
  },
  methods: {
    getDetail() {
      if (this.id) {
        // this.$store.dispatch("setActionNoticModal", {
        //   show: true,
        //   data: {
        //     type: "CompanyDetailsModal",
        //     title: this.name,
        //     width: 800,
        //     data: { id: this.id },
        //   },
        // });
      }
    },
  },
};
</script>
